export default __webpack_public_path__ + "static/ceyice-708cc8edba5b1da854427249c404e9a1.png";